import { sqliteTable, text, integer, real, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// leave_applications — ใบลา (Leave Application)
// ============================================================================
export const leaveApplications = sqliteTable("hr_leave_applications", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  applicationNo: text("application_no").notNull(),
  employeeId: text("employee_id").notNull(),
  leaveTypeId: text("leave_type_id").notNull(),
  fromDate: text("from_date").notNull(),
  toDate: text("to_date").notNull(),
  totalDays: real("total_days").notNull(),
  reason: text("reason"),
  status: text("status").notNull().default("draft"), // draft, pending, approved, rejected, cancelled
  approvedBy: text("approved_by"),
  approvedAt: text("approved_at"),
  rejectionReason: text("rejection_reason"),
  // Audit columns
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedBy: text("updated_by"),
  updatedAt: text("updated_at").notNull(),
  deletedBy: text("deleted_by"),
  deletedAt: text("deleted_at"),
}, (table) => ({
  la_company_idx: index("la_company_idx").on(table.companyId, table.status),
  la_employee_idx: index("la_employee_idx").on(table.companyId, table.employeeId),
  la_date_idx: index("la_date_idx").on(table.companyId, table.fromDate, table.toDate),
}));

// Type exports
export type LeaveApplication = typeof leaveApplications.$inferSelect;
export type NewLeaveApplication = typeof leaveApplications.$inferInsert;
